/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-07-01 10:14:53
 * @LastEditors: 刘洪壮 liuhongzhuang@nextmar.com
 * @LastEditTime: 2025-07-01 13:31:22
 * @FilePath: /zeelool-nextjs/src/app/payment/components/Popup/RepeatPopup/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import Button from '@/components/Button';
import Dialog from '@/components/Dialog';
import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';

interface RepeatPopupProps {
  show: boolean;
}

export default function RepeatPopup({ show }: RepeatPopupProps) {
  const t = useTranslations('payment.Popup');
  const router = useRouter();

  return (
    <Dialog
      open={show}
      onClose={() => {
        router.push('/cart?from=payment');
      }}
      footer={null}
      sx={{
        '& .MuiDialog-paper': {
          width: '400px',
          maxWidth: '100%',
        },
      }}
    >
      <div className="flex flex-col items-center justify-center">
        <h4 className="font-bb text-[20px] mb-[12px]">{t('OrderCannotBeSubmitted')}</h4>
        <p className="mb-[24px]">{t('CauseTheStatusOfProductsUpdated')}</p>
        <Button
          variant="contained"
          onClick={() => {
            router.push('/cart?from=payment');
          }}
          className="w-4/5"
        >
          {t('BackToCart')}
        </Button>
      </div>
    </Dialog>
  );
}
